import React from 'react';
import './footer.css';

function Footer({ onNavigate }) {
  return (
    <footer className='footersection'>
      <div className='footerBrand'>
        <h3>Viewjot</h3>
        <p>Technology-driven growth for modern businesses.</p>
      </div>

      <div className='leftfooter'>
        <p className='footerLabel'>Our Services</p>
        <p>Software Development</p>
        <p>Industrial Services</p>
        <button type='button' className='footerLink' onClick={() => onNavigate('career')}>
          Careers
        </button>
      </div>

      <div className='rightfooter'>
        <p className='footerLabel'>Socials</p>
        <p>Facebook</p>
        <p>X / Twitter</p>
        <p>Instagram</p>
      </div>
    </footer>
  );
}

export default Footer;